export default __webpack_public_path__ + "static/PaulPairetBig-89473f43ea060deb2bfcd5631af4b1f9.jpg";